import { Renderer2 } from "@angular/core";
import { Configuracoes } from "app/models/configuracoes.model";
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbLogin extends AppService {
  abstract skin: any;
  abstract redirecAccountList: any;
  abstract doNotRedirectAccountList: any;
  abstract refreshAttempt: number;
  abstract renderer2: Renderer2
  abstract doLogin(login: any);
  abstract refreshToken(accountSelected?, _redirectAccountList?, _doNotRedirectAccountList?);
  abstract validarTokenMfa(hashMfa: string, tokenMfa: string): Observable<any>;
  abstract enviarTokenMfa(hashMfa: string, fator: string): Observable<any>;
  abstract retry(doRefresh: boolean): boolean;
  abstract loadUser(token, accountSelected, doRefresh);
  abstract modalLGPD(user, accountSelected, doRefresh);
  abstract saveAcceptedLgpd(componentInstance, user, accountSelected, doRefresh);
  abstract registerUser(user, accountSelected, doRefresh);
  abstract getLogo(user, accountSelected);
  abstract loadLogo(integradorId, user, accountSelected);
  abstract returnAccountConfigSkin();
  abstract goHome(user, accountSelected);
  abstract blockedData(config: Configuracoes): any;
  abstract getCustomSkin(): Observable<any>;
  abstract getConfigIntegrador(uuid: string): Observable<any>;
}
